export const PlayInfo = {
  17: {
    chartid: 17,
    play_name: 'CQSSC',
    cat: 'SSC',
    pan: 'A',
    strategy: 'SSC',
    play_cname: '重庆时时彩',
    time: ['07:10:00', '03:30:00'],
    page: 'pk10',
    tip: '07:10:00~次日03:30:00',
    default: 17000,
    type: 2,
    color: true,
  },
  22: {
    chartid: 22,
    play_name: 'GD115',
    cat: '115',
    pan: 'A',
    strategy: '115',
    play_cname: '广东11选5',
    time: ['9:10:00', '23:10:00'],
    page: 'pk10',
    tip: '9:10:00-23:10:00',
    default: 22018,
    type: 2,
    color: true,
  },
  27: {
    chartid: 27,
    play_name: 'SH115',
    cat: '115',
    pan: 'A',
    strategy: '115',
    play_cname: '上海11选5',
    time: ['9:00:00', '24:00:00'],
    page: 'pk10',
    tip: '9:00:00-24:00:00',
    default: 27018,
    type: 2,
    color: true,
  },
  33: {
    chartid: 33,
    play_name: 'MARKSIX',
    cat: 'MARKSIX',
    pan: 'B',
    strategy: 'MARKSIX',
    play_cname: '香港六合彩',
    page: 'hklottery',
    tip: '花样新翻 六合共赢',
    default: '33000',
    type: 2,
  },
  464: {
    chartid: 464,
    play_name: 'TWDLT',
    cat: 'MARKSIX',
    pan: 'B',
    strategy: 'MARKSIX',
    play_cname: '台湾大乐透',
    page: 'hklottery',
    tip: '花样新翻 六合共赢',
    default: '464000',
    type: 2,
  },
  465: {
    chartid: 465,
    play_name: 'XJPDDLHC',
    cat: 'MARKSIX',
    pan: 'B',
    strategy: 'MARKSIX',
    play_cname: '澳门六合彩',
    page: 'hklottery',
    tip: '花样新翻 六合共赢',
    default: '465000',
    type: 2,
  },
  34: {
    chartid: 34,
    play_name: 'PK10',
    cat: 'PK10',
    pan: 'A',
    strategy: 'PK10',
    play_cname: '极速赛车',
    time: ['00:00:00', '24:00:00'],
    page: 'pk10',
    tip: '冠亚之争 由您来定',
    default: 34700,
    type: 2,
  },
  37: {
    chartid: 37,
    play_name: 'JSK3',
    cat: 'K3',
    pan: 'A',
    strategy: 'K3',
    play_cname: '江苏快3',
    time: ['8:30:00', '22:10:00'],
    page: 'k3',
    tip: '8:30:00-22:10:00',
    default: 37000,
    type: 2,
    color: true,
  },
  39: {
    chartid: 39,
    play_name: 'XJSSC',
    cat: 'SSC',
    pan: 'A',
    strategy: 'SSC',
    play_cname: '新疆时时彩',
    time: ['10:00:00', '2:00:00'],
    page: 'pk10',
    tip: '10:00:00-2:00:00',
    default: 39000,
    type: 2,
    color: true,
  },
  40: {
    chartid: 40,
    play_name: 'PC00',
    cat: 'PC00',
    pan: 'A',
    strategy: 'PC00',
    play_cname: '北京28',
    time: ['9:00:00', '24:00:00'],
    tip: '日场幸运狂欢',
    type: 1,
  },
  387: {
    chartid: 387,
    play_name: 'TWBINGO',
    cat: 'PC00',
    pan: 'A',
    strategy: 'PC00',
    play_cname: '台湾宾果',
    time: ['07:05:00', '23:55:00'],
    tip: '日场幸运狂欢',
    type: 1,
  },
  389: {
    chartid: 389,
    play_name: 'AZXY20',
    cat: 'PC00',
    pan: 'A',
    strategy: 'PC00',
    play_cname: '澳洲幸运20',
    time: ['00:00:00', '24:00:00'],
    tip: '日场幸运狂欢',
    type: 1,
  },
  41: {
    chartid: 41,
    play_name: 'JND00',
    cat: 'PC00',
    pan: 'A',
    strategy: 'PC00',
    play_cname: '加拿大28',
    time: ['21:05:00', '19:00:00'],
    tip: '午夜激情不停',
    type: 1,
  },
  42: {
    chartid: 42,
    play_name: 'CQLHC',
    cat: 'LHC',
    pan: 'B',
    strategy: 'LHC',
    play_cname: '重庆六合彩',
    note_tag: 'lhcMoney',
    time: ['07:10:00', '03:30:00'],
    page: 'cqlhc',
    tip: '花样新翻 六合共赢',
    norunAfter: true,
    default: 42000,
    type: 2,
  },
  43: {
    chartid: 43,
    play_name: 'TJSSC',
    cat: 'SSC',
    pan: 'A',
    strategy: 'SSC',
    play_cname: '天津时时彩',
    time: ['9:20:00', '23:20:00'],
    page: 'pk10',
    tip: '9:20:00-23:20:00',
    default: 43000,
    type: 2,
    color: true,
  },
  46: {
    chartid: 46,
    play_name: 'HUBK3',
    cat: 'K3',
    pan: 'A',
    strategy: 'K3',
    play_cname: '湖北快3',
    time: ['9:00:00', '22:00:00'],
    page: 'k3',
    tip: '9:00:00-22:00:00',
    default: 46000,
    type: 2,
    color: true,
  },
  47: {
    chartid: 47,
    play_name: 'BJK3',
    cat: 'K3',
    pan: 'A',
    strategy: 'K3',
    play_cname: '北京快3',
    time: ['9:00:00', '23:40:00'],
    page: 'k3',
    tip: '9:00:00-23:40:00',
    default: 47000,
    type: 2,
    color: true,
  },
  48: {
    chartid: 48,
    play_name: 'HEBK3',
    cat: 'K3',
    pan: 'A',
    strategy: 'K3',
    play_cname: '河北快3',
    time: ['8:30:00', '22:10:00'],
    page: 'k3',
    tip: '8:30:00-22:10:00',
    default: 48000,
    type: 2,
    color: true,
  },
  49: {
    chartid: 49,
    play_name: 'GSK3',
    cat: 'K3',
    pan: 'A',
    strategy: 'K3',
    play_cname: '甘肃快3',
    time: ['10:00:00', '22:00:00'],
    page: 'k3',
    tip: '10:00:00-22:00:00',
    default: 49000,
    type: 2,
    color: true,
  },
  50: {
    chartid: 50,
    play_name: 'SHK3',
    cat: 'K3',
    pan: 'A',
    strategy: 'K3',
    play_cname: '上海快3',
    time: ['8:40:00', '22:20:00'],
    page: 'k3',
    tip: '8:40:00-22:20:00',
    default: 50000,
    type: 2,
    color: true,
  },
  51: {
    chartid: 51,
    play_name: 'GZK3',
    cat: 'K3',
    pan: 'A',
    strategy: 'K3',
    play_cname: '贵州快3',
    time: ['9:10:00', '23:10:00'],
    page: 'K3',
    tip: '9:10:00-23:10:00',
    default: 51000,
    type: 2,
    color: true,
  },
  52: {
    chartid: 52,
    play_name: 'JX115',
    cat: '115',
    pan: 'A',
    strategy: '115',
    play_cname: '江西11选5',
    time: ['9:10:00', '23:10:00'],
    page: 'pk10',
    tip: '9:10:00-23:10:00',
    default: 52018,
    type: 2,
    color: true,
  },
  53: {
    chartid: 53,
    play_name: 'SD115',
    cat: '115',
    pan: 'A',
    strategy: '115',
    play_cname: '山东11选5',
    time: ['8:40:00', '23:00:00'],
    page: 'pk10',
    tip: '8:40:00-23:00:00',
    default: 53018,
    type: 2,
    color: true,
  },
  467: {
    chartid: 467,
    play_name: 'LN115',
    cat: '115',
    pan: 'A',
    strategy: '115',
    play_cname: '辽宁11选5',
    time: ['8:49:00', '22:29:00'],
    page: 'pk10',
    tip: '8:49:00-22:29:00',
    default: 467018,
    type: 2,
    color: true,
  },

  58: {
    chartid: 58,
    play_name: 'XYFT',
    cat: 'XYFT',
    pan: 'A',
    strategy: 'XYFT',
    play_cname: '老幸运飞艇',
    time: ['13:04:00', '4:04:00'],
    page: 'pk10',
    tip: '13:04:00~4:04:00',
    default: 58700,
    type: 2,
    termlong: 9,
  },
  99: {
    chartid: 58,
    play_name: 'XYFT',
    cat: 'XYFT',
    pan: 'A',
    strategy: 'XYFT',
    play_cname: '老幸运飞艇',
    time: ['13:04:00', '4:04:00'],
    page: 'pk10',
    tip: '13:04:00~4:04:00',
    default: 58700,
    type: 2,
    termlong: 9,
  },
  200: {
    chartid: 58,
    play_name: 'XYFT',
    cat: 'XYFT',
    pan: 'A',
    strategy: 'XYFT',
    play_cname: '老幸运飞艇',
    time: ['13:04:00', '4:04:00'],
    page: 'pk10',
    tip: '13:04:00~4:04:00',
    default: 58700,
    type: 2,
    termlong: 9,
  },
  203: {
    chartid: 58,
    play_name: 'XYFT',
    cat: 'XYFT',
    pan: 'A',
    strategy: 'XYFT',
    play_cname: '老幸运飞艇',
    time: ['13:04:00', '4:04:00'],
    page: 'pk10',
    tip: '13:04:00~4:04:00',
    default: 58700,
    type: 2,
    termlong: 9,
  },
  206: {
    chartid: 58,
    play_name: 'XYFT',
    cat: 'XYFT',
    pan: 'A',
    strategy: 'XYFT',
    play_cname: '老幸运飞艇',
    time: ['13:04:00', '4:04:00'],
    page: 'pk10',
    tip: '13:04:00~4:04:00',
    default: 58700,
    type: 2,
    termlong: 9,
  },
  209: {
    chartid: 58,
    play_name: 'XYFT',
    cat: 'XYFT',
    pan: 'A',
    strategy: 'XYFT',
    play_cname: '老幸运飞艇',
    time: ['13:04:00', '4:04:00'],
    page: 'pk10',
    tip: '13:04:00~4:04:00',
    default: 58700,
    type: 2,
    termlong: 9,
  },
  212: {
    chartid: 58,
    play_name: 'XYFT',
    cat: 'XYFT',
    pan: 'A',
    strategy: 'XYFT',
    play_cname: '老幸运飞艇',
    time: ['13:04:00', '4:04:00'],
    page: 'pk10',
    tip: '13:04:00~4:04:00',
    default: 58700,
    type: 2,
    termlong: 9,
  },
  215: {
    chartid: 58,
    play_name: 'XYFT',
    cat: 'XYFT',
    pan: 'A',
    strategy: 'XYFT',
    play_cname: '老幸运飞艇',
    time: ['13:04:00', '4:04:00'],
    page: 'pk10',
    tip: '13:04:00~4:04:00',
    default: 58700,
    type: 2,
    termlong: 9,
  },
  218: {
    chartid: 58,
    play_name: 'XYFT',
    cat: 'XYFT',
    pan: 'A',
    strategy: 'XYFT',
    play_cname: '老幸运飞艇',
    time: ['13:04:00', '4:04:00'],
    page: 'pk10',
    tip: '13:04:00~4:04:00',
    default: 58700,
    type: 2,
    termlong: 9,
  },
  221: {
    chartid: 58,
    play_name: 'XYFT',
    cat: 'XYFT',
    pan: 'A',
    strategy: 'XYFT',
    play_cname: '老幸运飞艇',
    time: ['13:04:00', '4:04:00'],
    page: 'pk10',
    tip: '13:04:00~4:04:00',
    default: 58700,
    type: 2,
    termlong: 9,
  },
  224: {
    chartid: 58,
    play_name: 'XYFT',
    cat: 'XYFT',
    pan: 'A',
    strategy: 'XYFT',
    play_cname: '老幸运飞艇',
    time: ['13:04:00', '4:04:00'],
    page: 'pk10',
    tip: '13:04:00~4:04:00',
    default: 58700,
    type: 2,
    termlong: 9,
  },
  743: {
    chartid: 743,
    play_name: 'JSFT',
    cat: 'XYFT',
    pan: 'A',
    strategy: 'XYFT',
    play_cname: '极速飞艇',
    time: ['00:00:00', '24:00:00'],
    page: 'pk10',
    tip: '猜你喜欢 极速飞艇',
    default: 743700,
    type: 2,
    termlong: 9,
  },
  78: {
    chartid: 78,
    play_name: 'TX1FC',
    cat: 'SSC',
    pan: 'A',
    strategy: 'SSC_TXFFC',
    play_cname: '腾讯分分彩',
    time: ['00:00:00', '24:00:00'],
    page: 'pk10',
    tip: '24小时在线购彩',
    default: 78000,
    type: 2,
    color: true,
  },

  // 自有C盘-公用
  111: {
    chartid: 17,
    play_name: 'CQSSCXY',
    cat: 'SSCJDC',
    pan: 'C',
    strategy: 'SSCJDC',
    play_cname: '重庆时时彩信用',
    time: ['07:10:00', '03:30:00'],
    page: 'pk10',
    tip: '07:10:00-03:30:00',
    default: 111000,
  },
  112: {
    chartid: 39,
    play_name: 'XJSSCXY',
    cat: 'SSCJDC',
    pan: 'C',
    strategy: 'SSCJDC',
    play_cname: '新疆时时彩信用',
    time: ['10:00:00', '2:00:00'],
    page: 'pk10',
    tip: '10:00:00-2:00:00',
    default: 112000,
  },
  109: {
    chartid: 34,
    play_name: 'PK10XY',
    cat: 'PK10JDC',
    pan: 'C',
    strategy: 'PK10JDC',
    play_cname: '极速赛车信用',
    time: ['00:00:00', '24:00:00'],
    page: 'pk10',
    tip: '冠亚之争 由您来定',
    default: 109000,
    termlong: 11,
  },
  110: {
    chartid: 58,
    play_name: 'XYFTXY',
    cat: 'XYFTJDC',
    pan: 'C',
    strategy: 'XYFTJDC',
    play_cname: '老幸运飞艇信用',
    time: ['13:04:00', '4:04:00'],
    page: 'pk10',
    tip: '冠亚之争 由您来定',
    default: 110000,
    termlong: 9,
  },

  753: {
    chartid: 753,
    play_name: 'FC3D',
    cat: 'FC3D',
    pan: 'A',
    strategy: 'FC3D',
    play_cname: '福彩3D',
    time: ['00:00:00', '24:00:00'],
    page: 'fc3d',
    tip: '24小时在线购彩',
    default: 753000,
  },

  // 境外彩
  385: {
    chartid: 385,
    play_name: 'AZXY10',
    cat: 'PK10JDC',
    pan: 'C',
    strategy: 'PK10JDC',
    play_cname: '澳洲幸运10',
    time: ['00:00:00', '24:00:00'],
    page: 'pk10',
    tip: '24小时在线购彩',
    default: 385000,
  },
  384: {
    chartid: 384,
    play_name: 'AZXY5',
    cat: 'SSCJDC',
    pan: 'C',
    strategy: 'SSCJDC',
    play_cname: '澳洲幸运5',
    time: ['00:00:00', '24:00:00'],
    page: 'pk10',
    tip: '24小时在线购彩',
    default: 384000,
  },
  23: {
    chartid: 23,
    disable: true,
    play_name: 'AHK3',
    cat: 'K3',
    pan: 'A',
    strategy: 'K3',
    play_cname: '安徽快3',
    time: ['8:40:00', '22:00:00'],
    page: 'k3',
    tip: '08:40:00~22:00:00',
    default: 23000,
    type: 2,
    color: true,
  },
};
